import Chart from "../chart";
import React from "react";
import { Alert, Badge, Col, Container, Row, Table } from "react-bootstrap";
import Icon from '../Icon';
import { faCheckCircle as checkmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { useData } from "@/storage/accessors";
import { useScreenSize } from "@/contexts/screenSizeContext";

type IsDoneProps = {
    title: string
    isDone: boolean
    inline: boolean
}

function DoneItem({ title, isDone, inline = true }: IsDoneProps) {
    const success = <><Icon icon={checkmarkCircle} /> <span style={{ wordBreak: 'break-word' }}>{title}</span></>;
    return <>
        {isDone ? (inline ? <Badge bg={"success"} className="text-wrap" style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}><small>{success}</small></Badge> : <Alert className="mb-1 mt-1 pb-2 pt-2" variant={"success"}><small>{success}</small></Alert>) :
            inline ? <small style={{ wordBreak: 'break-word' }}>{title}</small> : <Alert className="mb-1 mt-1 pb-2 pt-2" variant={"light"}><small>{title}</small></Alert>}
    </>
}

export default function SummaryTab() {
    const screenSize = useScreenSize();
    const isMobile = screenSize === "MOBILE";
    const { roles, goals } = useData();
    let parts = Object.values(roles.objects).sort((a, b) => (a.order || 0) - (b.order || 0));
    let numbers: number[] = [];
    for (let i = 0; i < 10; i++) numbers.push(i + 1);

    return (
        <Container fluid className="px-0 mx-0" style={{ overflowX: 'hidden', maxWidth: '100%' }}>
            <Row className="mx-0">
                {isMobile ? (
                    <>
                        <Col xs={12} className="mb-3 text-center px-0">
                            <h3>Статистика</h3>
                        </Col>
                        <Col xs={12} className="px-0">
                            <Chart maxLabelChars={20} roles={parts} showLabels={false} />
                        </Col>
                        <Col xs={12} className="px-0" style={{ marginTop: 30 }}>
                            <Table striped bordered hover className="mb-0" style={{ tableLayout: 'fixed', wordBreak: 'break-word' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '40%' }}>Баланс</th>
                                        <th style={{ width: '60%' }}>Цели</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parts.map((part, partIndex) => (
                                        <tr key={part.uuid}>
                                            <td className="align-middle">
                                                <div className="mb-1">{partIndex + 1}. {part.name}</div>
                                                {(!part.successSigns || part.successSigns.length === 0) && (
                                                    <div className="text-muted mt-1"><small>нет критериев</small></div>
                                                )}
                                            </td>
                                            <td className="align-middle">
                                                {Object.values(goals.objects).filter(s => s.lifepart === part.uuid).map(
                                                    (step, index) => <div key={step.uuid} className="mb-1" style={index > 0 ? { borderTop: '1px solid #dee2e6', paddingTop: 8 } : {}}><DoneItem title={`${step.description}`} isDone={step.isDone} inline /></div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </>
                ) : (
                    <>
                        <Col md={5} className="px-3">
                            <Chart maxLabelChars={20} roles={parts} showLabels={false} />
                        </Col>
                        <Col md={6} className="px-3" style={{ marginTop: 70 }}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th className="col-2">Баланс </th>
                                        <th className="col-3">Цели</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parts.map((part, partIndex) => (
                                        <tr key={part.uuid}>
                                            <th>
                                                <div className="mb-1">{partIndex + 1}. {part.name}</div>
                                                {(!part.successSigns || part.successSigns.length === 0) && (
                                                    <div className="text-muted mt-1"><small>нет критериев</small></div>
                                                )}
                                            </th>
                                            <td>
                                                {Object.values(goals.objects).filter(s => s.lifepart === part.uuid).map(
                                                    step => <div key={step.uuid}><DoneItem title={`${step.description}`} isDone={step.isDone} inline /></div>

                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </>
                )}
            </Row>
            <Row>

            </Row>
        </Container>
    );
}
